import { ProductionOrderUpdatePage } from "@/features/production/pages/ProductionOrderUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/production/$id/update")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["production.edit"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ProductionOrderUpdatePage,
});
